import { Controller } from 'react-hook-form'
import { RadioGroup } from '../../../../components'
import { Currency } from '../../../../gql/types'
import { PricingData, getVideoPricing } from '../../../../utils/PricingUtil'
import { addonsOptions } from '../../../../utils/mappers'

interface Props {
  errors: any
  register: any
  control: any
  watch: any
  currency: Currency
  pricing: PricingData
  hidePricing?: boolean
}

const EditAddons = ({
  errors,
  watch,
  control,
  register,
  currency,
  pricing,
  hidePricing,
}: Props) => {
  const videoPricing = getVideoPricing({
    currency: currency,
    videoDuration: watch('videoDuration'),
    pricing,
  })

  return (
    <div>
      <div className='mt-10 sm:mt-0'>
        <div className='md:grid md:grid-cols-3 md:gap-6'>
          <div className='md:col-span-1'>
            <div className=''>
              <h3 className='text-lg font-semibold font-sans leading-6 text-gray-900'>
                Add-ons
              </h3>
              <p className='mt-1 text-sm font-normal font-sans leading-5 text-gray-500'>
                Customize additional add-ons within your campaign to suit your
                specific needs.
              </p>
            </div>
          </div>
          <div className='mt-5 md:col-span-2 md:mt-0'>
            <div className='md:shadow rounded-t-md sm:overflow-hidden'>
              <div className='py-5 md:bg-white space-y-6 sm:p-6'>
                <div className='grid gap-6'>
                  <div className='col-span-3 sm:col-span-2'>
                    <Controller
                      name='addonsSubtitlesMusic'
                      control={control}
                      render={({ field }) => (
                        <RadioGroup
                          options={addonsOptions(
                            videoPricing.addons,
                            currency,
                            hidePricing,
                          )}
                          field={field}
                          error={errors?.addonsSubtitlesMusic?.message}
                          allowDeselect={true}
                          deselectTitle={`Remove Add-on`}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='hidden sm:block' aria-hidden='true'>
        <div className='py-5'>
          <div className='border-t border-gray-200' />
        </div>
      </div>
    </div>
  )
}

export { EditAddons }
